import { useState, useEffect, useMemo, useCallback } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useUserSelector } from 'js/store/hooks';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { getPlayerTags } from 'js/hooks/user/server';

export const usePlayerTags = ({ fields, setIsFormLoading }) => {
    const isMounted = useIsMounted();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const [playerTags, setPlayerTags] = useState([]);
    const hasPlayerTagFields = useMemo(() => fields.some(field => field.usePlayerTags), [fields]);

    const fetchPlayerTags = useCallback(async () => {
        try {
            setIsFormLoading(true);

            const response = await getPlayerTags();

            isMounted() && setPlayerTags(response?.data?.tags || []);
        } catch {
            isMounted() && setPlayerTags([]);
        } finally {
            isMounted() && setIsFormLoading(false);
        }
    }, [setPlayerTags, isMounted, setIsFormLoading]);

    useEffect(() => {
        if (!hasPlayerTagFields) {
            return;
        }

        if (isLoggedIn) {
            (async () => fetchPlayerTags())();
        } else {
            setPlayerTags([]);
        }
    }, [isLoggedIn, fetchPlayerTags, setPlayerTags, hasPlayerTagFields]);

    return [playerTags, fetchPlayerTags];
};
